import TermsOfService from "../modules/terms-of-use/templates/term";

const PageTermsOfService = () => <TermsOfService />;

export default PageTermsOfService;
